var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRocketIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M18 22.8978L13.5 18.3978M18 22.8978C20.0953 22.1009 22.1053 21.0959 24 19.8978M18 22.8978V30.3978C18 30.3978 22.545 29.5728 24 27.3978C25.62 24.9678 24 19.8978 24 19.8978M13.5 18.3978C14.2982 16.327 15.3033 14.3419 16.5 12.4728C18.2478 9.67831 20.6814 7.37741 23.5695 5.78897C26.4576 4.20053 29.704 3.37739 33 3.39783C33 7.47783 31.83 14.6478 24 19.8978M13.5 18.3978H6C6 18.3978 6.825 13.8528 9 12.3978C11.43 10.7778 16.5 12.3978 16.5 12.3978M6.75 25.1478C4.5 27.0378 3.75 32.6478 3.75 32.6478C3.75 32.6478 9.36 31.8978 11.25 29.6478C12.315 28.3878 12.3 26.4528 11.115 25.2828C10.532 24.7263 9.76394 24.4048 8.95834 24.3799C8.15274 24.355 7.36631 24.6284 6.75 25.1478Z",
    stroke: "#087AE4",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketIcon);
export default __webpack_public_path__ + "static/media/rocketIcon.1fb881e626856cadc70fc01161c0a7c8.svg";
export { ForwardRef as ReactComponent };